<dynamicdata [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [COMMONSERVICE]="dynamic$"></dynamicdata>